var map = {
	"./assets/audio/ArcadeWin.mp3": 60,
	"./assets/audio/Bells.mp3": 61,
	"./assets/audio/BigWin.mp3": 62,
	"./assets/audio/BonusWheel_MUSIC_END.mp3": 63,
	"./assets/audio/BonusWheel_MUSIC_LOOP.mp3": 64,
	"./assets/audio/GlitterAir.mp3": 65,
	"./assets/audio/Skeeballthrowroll.mp3": 66,
	"./assets/audio/ballHit1.mp3": 67,
	"./assets/audio/ballHopper.mp3": 68,
	"./assets/audio/balltrayFill.mp3": 69,
	"./assets/audio/beeda_loo.mp3": 70,
	"./assets/audio/blip.mp3": 71,
	"./assets/audio/clack1.mp3": 72,
	"./assets/audio/extraBall.mp3": 73,
	"./assets/audio/failSound.mp3": 74,
	"./assets/audio/fallinHole.mp3": 75,
	"./assets/audio/hit.mp3": 76,
	"./assets/audio/hit2.mp3": 77,
	"./assets/audio/inHole.mp3": 78,
	"./assets/audio/ramp.mp3": 79,
	"./assets/audio/ramp2.mp3": 80,
	"./assets/audio/rampRoll.mp3": 81,
	"./assets/audio/rolldown.mp3": 82,
	"./assets/audio/snare.mp3": 83,
	"./assets/audio/squirtle.mp3": 84,
	"./assets/audio/wav/hit3clang.mp3": 85,
	"./site/NY/build/audio/ArcadeWin.mp3": 86,
	"./site/NY/build/audio/Bells.mp3": 87,
	"./site/NY/build/audio/BigWin.mp3": 88,
	"./site/NY/build/audio/BonusWheel_MUSIC_END.mp3": 89,
	"./site/NY/build/audio/BonusWheel_MUSIC_LOOP.mp3": 90,
	"./site/NY/build/audio/GlitterAir.mp3": 91,
	"./site/NY/build/audio/Skeeballthrowroll.mp3": 92,
	"./site/NY/build/audio/ballHit1.mp3": 93,
	"./site/NY/build/audio/ballHopper.mp3": 94,
	"./site/NY/build/audio/balltrayFill.mp3": 95,
	"./site/NY/build/audio/beeda_loo.mp3": 96,
	"./site/NY/build/audio/blip.mp3": 97,
	"./site/NY/build/audio/clack1.mp3": 98,
	"./site/NY/build/audio/extraBall.mp3": 99,
	"./site/NY/build/audio/failSound.mp3": 100,
	"./site/NY/build/audio/fallinHole.mp3": 101,
	"./site/NY/build/audio/hit.mp3": 102,
	"./site/NY/build/audio/hit2.mp3": 103,
	"./site/NY/build/audio/hit3clang.mp3": 104,
	"./site/NY/build/audio/inHole.mp3": 105,
	"./site/NY/build/audio/ramp.mp3": 106,
	"./site/NY/build/audio/ramp2.mp3": 107,
	"./site/NY/build/audio/rampRoll.mp3": 108,
	"./site/NY/build/audio/rolldown.mp3": 109,
	"./site/NY/build/audio/snare.mp3": 110,
	"./site/NY/build/audio/squirtle.mp3": 111
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;



//////////////////
// WEBPACK FOOTER
// ./app ./~/file-loader?name=audio/[name].mp3!^\.\/.*\.mp3$
// module id = 59
// module chunks = 0